/*
 * @Description: 全国行政区
 * @Author: cxh
 * @Date: 2022-07-08 10:43:01
 * @LastEditTime: 2022-11-08 14:34:41
 * @LastEditors: cxh
 */
import { defineStore } from 'pinia'
import { adminArea } from '@/api/common'
import { useRequest } from 'vue-request'
export const useAreaStore = defineStore({
  id: 'area',
  state: () => ({
    area: []
  }),
  actions: {
    async fetchData() {
      return new Promise((resolve, reject) => {
        useRequest(adminArea, {
          defaultParams: [{ appId: 'cos_fbu' }],
          cacheKey: 'appId_cos_fbu_area',
          onSuccess: (res) => {
            this.$patch({
              area: res.data
            })
            resolve(res)
          },
          onError(Error) {
            reject(Error)
          }
        })
      })
    }
  }
})
